<template>
  <div
    :class="{'boss-check': check}"
    class="boss-resumecard-item"
  >
    <scout-resume-card-avatar
      :id="memberObject.id"
      :member="memberObject.member"
      :checked="checked"
      :is-scouted="isScouted"
      :is-show-checkbox="isShow"
      :is-show-scout-decline="isShowScoutDecline"
      @change="(arg) => $emit('change', arg)"
    />
    <div class="boss-resumecard-item-right">
      <div class="boss-resumecard-details">
        <div class="boss-resumecard-overview clearfix">
          <div
            class="boss-resumecard-overview-title"
            data-test="member-summary"
          >
            {{ getNameOrUndefined(memberObject.member, 'presentAddressPrefecture.name') | parseBlankForDefaultValue('--', '', '', false) }} {{ memberObject.member.birthdate | parseAge | parseBlankForDefaultValue('--', '', '歳', false) }} {{ getNameOrUndefined(memberObject.member, 'gender.name') | parseBlankForDefaultValue('--', '', '', false) }} /{{ memberObject.member.employed | convertEmployedLabel | parseBlankForDefaultValue('--', '', '', false) }}/{{ getNameOrUndefined(memberObject.member, 'careerResume.annualSalary') | parseNumberValue('--', '年収', '万円', false) }}/{{ memberObject.member.changeOverJobsCount | parseNumberValue('--', '転職', '回', false) }}
          </div>
          <dl class="boss-resumecard-overview-list">
            <dt class="boss-resumecard-overview-item">
              <span class="boss-resumecard-head">直近の経験職種</span>
            </dt>
            <dd
              class="boss-resumecard-overview-body"
              data-test="member_experienced_occupation"
            >
              {{ convertSliceObjectLabelSuffixYear(memberObject.member.experiencedOccupations, 0, 1) |parseBlankForDefaultValue('') }}
            </dd>
          </dl>
          <dl class="boss-resumecard-overview-list">
            <dt class="boss-resumecard-overview-item">
              <span class="boss-resumecard-head">希望職種</span>
            </dt>
            <dd
              class="boss-resumecard-overview-body"
              data-test="member_desired_occupation"
            >
              {{ convertSliceObjectLabel(memberObject.member.desiredOccupations, 0, 1) |parseBlankForHopeValue() }}
            </dd>
          </dl>
          <div class="boss-layout boss-layout-no-gap">
            <dl class="boss-resumecard-overview-list">
              <dt class="boss-resumecard-overview-item">
                <span class="boss-resumecard-head">希望勤務地</span>
              </dt>
              <dd
                class="boss-resumecard-overview-body"
                data-test="member_desired_work_prefecture"
              >
                {{ convertSliceArrayLabel(memberObject.member.desiredWorkPrefectures, 0, 1) |parseBlankForHopeValue() }}
              </dd>
            </dl>
            <dl class="boss-resumecard-overview-list">
              <dt class="boss-resumecard-overview-item">
                <span class="boss-resumecard-head">希望年収</span>
              </dt>
              <dd
                class="boss-resumecard-overview-body"
                data-test="member_desiredSalary"
              >
                {{ memberObject.member.desiredSalary | parseBlankForDefaultValue('', '', '万円') }}
              </dd>
            </dl>
          </div>
          <template v-if="!isScouted">
            <scout-resume-card-detail
              v-if="!isMaskingTarget"
              :member="memberObject.member"
              :comment="comment"
            />
            <div v-else>
              {{ maskingLabel }}
            </div>
          </template>
          <div
            v-if="isScouted"
            class="boss-scout-mail"
          >
            <ul class="boss-scout-status">
              <li
                v-if="scoutTitle"
                class="boss-scout-status-item"
              >
                <div class="boss-ellipsis-block">
                  <span
                    class="boss-scout-status-date"
                    data-test="scout-datetime"
                  >{{ scoutDateTime }}</span>
                  <span
                    class="boss-scout-status-subject"
                    data-test="scout-title"
                  >{{ scoutTitle }}</span>
                </div>
              </li>
              <li
                v-if="scoutedCounts"
                class="boss-scout-status-item boss-send-number"
              >
                <span
                  class="boss-scout-status-text"
                  data-test="scout-count"
                >{{ scoutedCounts }}</span>
              </li>
              <li
                v-if="scoutSpecialFavors && scoutSpecialFavors.length"
                class="boss-scout-status-item boss-scout-bonus"
              >
                <span
                  v-for="(specialFavor, index) in scoutSpecialFavors"
                  :key="index"
                  v-tooltip="{ content: specialFavorBy(specialFavor.id).description}"
                  :data-test="'scout-special-favor-' + index"
                  :class="{ 'boss-bonus-end': !specialFavor.isEffective }"
                  class="boss-bonus-check-text boss-check-true"
                >{{ specialFavor.name }}</span>
              </li>
            </ul>
          </div>
          <div
            v-if="memberObject.member.searchConditionName"
            class="boss-scout-status-item"
          >
            <span
              class="boss-scout-status-text"
              data-test="member-search-condition-name"
            >検索条件名：{{ memberObject.member.searchConditionName }}</span>
          </div>
        </div>
        <div
          class="boss-resumecard-button-list"
        >
          <div class="boss-layout boss-layout-vertical boss-layout-fill">
            <div
              v-if="isExcluded"
              class="resumecard-button-list-list"
            >
              <span
                class="boss-button boss-button-strong boss-button-fill boss-button-small"
                data-test="restore"
                @click="onRestoreClick"
              >
                <span>検索対象に戻す</span>
              </span>
            </div>
            <div
              v-if="showsLikeButton && !isMaskingTarget && canApproach"
              class="resumecard-button-list-list"
            >
              <span
                :class="{'boss-button-pushed': hasLike}"
                data-test="like"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button"
                :disabled="isLikeLimitOver && !hasLike"
                @click="onRegisterLike(memberObject.member.id)"
              >
                <img
                  v-if="hasLike"
                  src="@/assets/images/icon-heart-fill.svg"
                  alt
                >
                <img
                  v-else
                  src="@/assets/images/icon-heart.svg"
                  alt
                >
                <span>{{ hasLike ? 'いいね済み' : 'いいね' }}</span>
              </span>
            </div>
            <div
              v-if="showsScoutButton && !isMaskingTarget && canApproach"
              class="resumecard-button-list-list"
            >
              <span
                v-if="isLikedViewAndScouted"
                type="button"
                data-test="scout-scouted"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button boss-button-pushed"
              >スカウト済み</span>
              <span
                v-else-if="isReserved"
                type="button"
                data-test="scout-reserved"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button boss-button-pushed"
              >予約中</span>
              <a
                v-else-if="isScoutInvalid"
                disabled
                type="button"
                data-test="scout-invalid"
                class="boss-button boss-button-strong boss-button-fill boss-button-small pega-button"
              >再送期限切れ</a>
              <a
                v-else
                data-test="scout-create"
                class="boss-button boss-button-strong boss-button-fill boss-button-small"
                @click="$router.push({ name: 'scoutCreate', params: { idAndNameObjects: [ { userId: memberObject.member.id, searchConditionName: searchConditionName}], jobId: jobId, contractId: contractId } })"
              >
                <span class="boss-icon boss-icon-scout boss-button-icon-large" />
                <span>スカウト</span>
              </a>
            </div>
            <div
              class="resumecard-button-list-list"
            >
              <a
                class="boss-button boss-button-outline boss-button-fill boss-button-small"
                data-open="boss-modal-control"
                data-test="open-detail"
                @click="onReveal"
              >
                <span>詳細を見る</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <scout-member-detail
      :id="memberObject.id"
      :contract-id="contractId"
      :job-id="jobId"
      :show-detail="showDetail"
      :user-id="memberObject.member.id"
      :search-condition-name="searchConditionName"
      :is-show-checked-close-button="isShow"
      :shows-excluded-button="showsExcludedButton"
      :is-show-scout-decline="isShowScoutDecline"
      :is-show-more-history.sync="isShowMoreHistory"
      @check-from-child="checkFromChild"
      @update-comment="updateComment"
      @update-member-excluded="updateMemberExcluded"
    />
  </div>
</template>

<script>
import ScoutResumeCardAvatar from '@/components/molecules/ScoutResumeCardAvatar'
import ScoutResumeCardDetail from '@/components/molecules/ScoutResumeCardDetail'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import ScoutMemberDetail from '@/components/templates/ScoutMemberDetail'
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import { mapMutations, mapGetters } from 'vuex'
import * as parse from '@/lib/parse'
import { createDate } from '@/lib/dateUtils.js'

export default {
  components: { ScoutResumeCardAvatar, ScoutResumeCardDetail, ScoutMemberDetail },
  filters: {
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は
    // 第2引数（unregisterdValue）+ '未登録' を返却する
    // それ以外の場合は 第3引数(prefix) + 第1引数（label）+ 第4引数（suffix）を返却する
    // 第5引数はlabelが無効の時に未登録を付与するかどうか
    parseBlankForDefaultValue (label, unregisteredValue, prefix = '', suffix = '', isUnregisteredLabel = true) {
      return label ? prefix + label + suffix : isUnregisteredLabel ? unregisteredValue + '未登録' : unregisteredValue
    },
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は
    // 'こだわらない・未入力' を返却する
    // それ以外の場合は 第3引数(prefix) + 第1引数（label）+ 第4引数（suffix）を返却する
    parseBlankForHopeValue (label, prefix = '', suffix = '') {
      return label ? prefix + label + suffix : 'こだわらない・未入力'
    },
    parseNumberValue (value, unregisteredValue, prefix = '', suffix = '', isUnregisteredLabel = true) {
      return parse.numberValue(value, suffix, unregisteredValue, prefix, isUnregisteredLabel)
    },
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertEmployedLabel (value) {
      return value || value === false ? definition.employed.find(employed => employed.value === value).name : ''
    }
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    memberObject: {
      type: Object,
      required: true
    },
    checked: {
      type: Array,
      default: () => ([])
    },
    isScouted: {
      type: Boolean,
      default: false
    },
    isLike: {
      type: Boolean,
      default: false
    },
    contractId: {
      type: Number,
      default: null
    },
    jobId: {
      type: Number,
      default: null
    },
    isPublishJob: {
      type: Boolean,
      default: false
    },
    searchedConditionName: {
      type: String,
      default: ''
    },
    searchedConditionId: {
      type: Number,
      default: null
    },
    showsLikeButton: {
      type: Boolean,
      default: true
    },
    showsScoutButton: {
      type: Boolean,
      default: true
    },
    isExcluded: {
      type: Boolean,
      default: false
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    showsCheckControl: {
      type: Boolean,
      default: true
    },
    needsCheckControl: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasLike: _.get(this.memberObject, 'member.liked', false),
      showDetail: false,
      comment: _.defaultTo(_.get(this.memberObject, 'member.approachComment'), ''),
      isShowMoreHistory: false
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'isLikeLimitOverBy',
      'contracts',
      'canScoutResend'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    check () {
      return _.includes(this.checked, this.memberObject.id)
    },
    searchConditionName () {
      return this.memberObject.member.searchConditionName ? this.memberObject.member.searchConditionName : _.defaultTo(this.searchedConditionName, '')
    },
    scoutTitle () {
      const title = _.get(this.memberObject.member, 'scout.latestMessage.subject')
      return (title) ? `件名： ${title}` : ''
    },
    scoutDateTime () {
      return createDate(_.get(this.memberObject.member, 'scout.latestMessage.insertDate'))?.format('YYYY-MM-DD HH:mm') ?? ''
    },
    scoutedCounts () {
      const count = _.get(this.memberObject.member, 'scout.messagesCount')
      return (count) ? `送信回数：${count}回` : ''
    },
    scoutSpecialFavors () {
      return _.get(this.memberObject.member, 'scout.specialFavors')
    },
    isScoutInvalid () {
      return this.isScouted && !this.isPublishJob && !this.canScoutResend(this.contractId, this.jobId)
    },
    canApproach () {
      return !_.get(this.memberObject, 'member.isScoutExcluded') && !_.get(this.memberObject, 'member.isEntry') && !_.get(this.memberObject, 'member.isScoutDecline')
    },
    isMaskingTarget () {
      return _.get(this.memberObject, 'member.isCkUser') || _.get(this.memberObject, 'member.isScoutRejection') ||
        _.get(this.memberObject, 'member.isWithdrawn') || !_.get(this.memberObject, 'member.subscriptions.scout')
    },
    maskingLabel () {
      const label = _.get(this.memberObject, 'member.isWithdrawn') ? '退会済み' : '利用停止'
      return `${label}のため表示できません。`
    },
    isLikeLimitOver () {
      return this.isLikeLimitOverBy(this.contractId)
    },
    isReserved () {
      return _.get(this.memberObject, 'member.isScoutReserved')
    },
    canScoutSent () {
      return this.canApproach &&
        !this.isReserved &&
        !this.isMaskingTarget &&
        !this.isLikedViewAndScouted
    },
    isShow () {
      return this.showsCheckControl && (this.needsCheckControl ? this.canScoutSent : true)
    },
    isShowScoutDecline () {
      return (this.isScouted || this.isLike) && _.get(this.memberObject, 'member.isScoutDecline')
    },
    isLikedViewAndScouted () {
      return _.get(this.memberObject, 'member.scouted') && this.isLike
    },
    showsExcludedButton () {
      return !this.isExcluded && !_.get(this.memberObject, 'member.isScoutExcluded')
    }
  },
  beforeDestroy () {
    this.modalResumeWindow && this.modalResumeWindow.close()
  },
  methods: {
    convertSliceArrayLabel (value, begin, end) {
      if (!value) return ''
      return value.slice(begin, end).map(v => this.getNameOrUndefined(v, 'name')).join('、')
    },
    convertSliceObjectLabelSuffixYear (value, begin, end) {
      if (!value || !value.length) return ''
      return value.slice(begin, end).map(v => {
        const label = this.getNameOrUndefined(v, 'name') + ' '
        const yearLabel = v.years !== null ? (v.years === 0 ? '1ヶ月以上' : v.years + '年') : '経験年数未設定'
        return label + yearLabel
      }).join('、')
    },
    convertSliceObjectLabel (value, begin, end) {
      if (!value || !value.length) return ''
      return value.slice(begin, end).map(v => {
        return this.getNameOrUndefined(v, 'name')
      }).join('、')
    },
    getNameOrUndefined (val, path) {
      return _.get(val, path)
    },
    openReveal () {
      if (!this.modalResumeWindow) {
        this.modalResumeWindow = new Foundation.Reveal(jQuery('#boss-modal-control-' + this.memberObject.member.id), {
          // These options can be declarative using the data attributes
          // animationIn: 'scale-in-up'
        })
        this.$set(this, 'showDetail', true)

        // 開く際にスクロール記憶をリセットする設定
        jQuery(`#boss-modal-control-${this.memberObject.member.id}`).on('open.zf.reveal', () => {
          jQuery(`#boss-modal-control-${this.memberObject.member.id}`).scrollTop(0)
        })
      }
      this.modalResumeWindow.open()
    },
    checkFromChild (id) {
      this.$emit('checked', id)
    },
    onRegisterLike (userId) {
      if (!this.hasLike && !this.isLikeLimitOver) {
        this.$set(this, 'hasLike', true)
        const apiParameter = [{ userId: userId, searchConditionName: this.searchConditionName }]
        this.$http.secured.post(`/scout/message/send/scouts/contracts/${this.contractId}/jobs/${this.jobId}/likes`, apiParameter)
          .then(response => {
            this.$toasted.global.like()
            this.fetchLikeAmount({ contractId: this.contractId })
            if (this.searchedConditionId) {
              this.updateSearchNewResultRead()
            } else if (this.memberObject.member.recommendedId) {
              this.updateRecommendRead()
            }
            this.$emit('updateLiked', { id: userId, liked: true })
          }).catch(() => {
            this.$set(this, 'hasLike', false)
          })
      }
    },
    updateComment (comment) {
      this.comment = comment
    },
    onReveal () {
      // モーダルを開く際は常に子のスカウト履歴一覧を閉じて表示するようにしておく
      this.$set(this, 'isShowMoreHistory', false)
      this.openReveal()
      if (this.searchedConditionId) {
        this.updateSearchNewResultRead()
      } else if (this.memberObject.member.recommendedId) {
        this.updateRecommendRead()
      }
    },
    updateRecommendRead () {
      if (this.memberObject.member.isNew) {
        this.$http.secured.patch(`scout/view/recommends/${this.memberObject.member.recommendedId}/resume/_is_read`).then((response) => {
          this.memberObject.member.isNew = false
        })
      }
    },
    updateSearchNewResultRead () {
      if (this.memberObject.member.isNew) {
        this.$http.secured.patch(`scout/view/scouts/search_conditions/${this.searchedConditionId}/users/${this.memberObject.member.id}/_is_read`).then((response) => {
          this.memberObject.member.isNew = false
        })
      }
    },
    onRestoreClick () {
      this.$http.secured.delete('/scout/view/company/excluded_users', { data: [this.memberObject.id] }).then(() => {
        this.$emit('fetch')
        this.$toasted.global.success({ message: '検索対象に戻しました。' })
      })
    },
    ...mapMutations('contracts', [
      'fetchLikeAmount'
    ]),
    updateMemberExcluded () {
      _.set(this.memberObject, 'member.isScoutExcluded', true)
      this.check && this.$emit('spliceCheckedMember', this.memberObject.id)
    }
  }
}
</script>
